import { usePage } from '@inertiajs/react'
import UnitForm from './UnitForm'
import { t } from '@/shared/lib/i18n'
import { departmentsPath, unitsPath, organizationPath } from '@/shared/lib/routes'
import { useBreadcrumbs } from '@/shared/lib/breadcrumbs-context'
import type { WeekdaySchedule } from '@/shared/ui/weekly-schedule-grid'

interface DepartmentOption {
  value: number
  label: string
  siteName: string | null
}

interface Props {
  departments: DepartmentOption[]
  departmentId?: number | null
  customDaySchedule: WeekdaySchedule
  parentDaySchedule: WeekdaySchedule
  [key: string]: unknown
}

const NewUnitPage = () => {
  const { departments, departmentId, customDaySchedule, parentDaySchedule } = usePage<Props>().props

  useBreadcrumbs([
    { label: t('nav.administration'), href: organizationPath() },
    { label: t('nav.departmentsAndUnits'), href: departmentsPath() },
    { label: t('nav.units'), href: unitsPath() },
    { label: t('organization.units.newUnit') },
  ])

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">{t('organization.units.newUnit')}</h1>
      <UnitForm
        departments={departments}
        initialData={{ departmentId: departmentId ?? undefined }}
        customDaySchedule={customDaySchedule}
        parentDaySchedule={parentDaySchedule}
        submitUrl={unitsPath()}
        submitMethod="post"
      />
    </div>
  )
}

export default NewUnitPage
